
import Vue from "vue";
import AppMissingModuleModal from "@/components/common/MissingModuleModal.vue";

export default Vue.extend({
	data() {
		return {
			missingModule: false
		};
	},
	props: {
		value: Number,
		fullControl: Boolean,
		tabs: Array as () => ([number, string])[],
		showAdvancedSettings: Boolean
	},
	methods: {
		clicked(index: null | number) {
			this.$emit("input", index);
		},
	},
	components: {
		AppMissingModuleModal
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
